import logo from './logo.svg';
import './App.css';
import { MainNavigator } from './AdminNavigator/MainNavigator';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file


function App() {
    return (
        <MainNavigator />
    )
}

export default App;
